import { Box, BoxProps } from "@mui/material";
import { SenecCard } from "src/components/cards/base/SenecCard";

export interface BasicSquaredCardProps extends BoxProps {
    /**
     * Set the card height in percent compared to the card's width.
     * Default value is 100%
     */
    cardHeightInPercent?: string;
}

/**
 * @deprecated Use SenecTile instead
 *
 * SenecCard used to structure content in a card with padding of 12px.
 */
export const BasicSquaredCard = ({ cardHeightInPercent = "100%", ...props }: BasicSquaredCardProps) => {
    return (
        <SenecCard>
            <Box
                sx={{
                    position: "relative",
                    paddingBottom: cardHeightInPercent,
                }}
                {...props}
            >
                <Box
                    sx={{
                        position: "absolute",
                        cursor: "pointer",
                        inset: 0,
                    }}
                >
                    {props.children}
                </Box>
            </Box>
        </SenecCard>
    );
};
